import classNames from "classnames/bind";
import SmartLink from "common/wrapper/SmartLink";
import Trustpilot from "public/icons/illustrations/Trustpilot.svg";
import Star from "public/icons/ui/Star.svg";
import type { ResolvedReview } from "resolvers/data/trustpilotResolver";
import dayjs, { DateFormat } from "utils/dayjs";
import styles from "./Review.module.scss";

const cx = classNames.bind(styles);

export interface ReviewProps extends ResolvedReview {
    service: string;
    prefetch?: boolean;
}

const Review: React.FC<ReviewProps> = ({
    name,
    quote,
    date,
    rating,
    href,
    service,
    prefetch = false,
}) => {
    return (
        <div className={cx("container")}>
            <SmartLink href={href} prefetch={!!prefetch}>
                <a className={cx("card")} target="_blank" rel="nofollow">
                    <div className={cx("stars")}>
                        {[...Array(5)].map((_, i) => (
                            <Star key={i} className={cx("star", { filled: i + 1 <= rating })} />
                        ))}
                    </div>

                    <blockquote className={cx("quote")}>{quote}</blockquote>
                    <div className={cx("footer")}>
                        <div className={cx("info")}>
                            <figcaption className={cx("customer")}>
                                {(name || "Trusted Customer") +
                                    " | " +
                                    dayjs(date).tz("Europe/London").format(DateFormat.WeekDayLong)}
                            </figcaption>
                        </div>
                        <div className={cx("service")}>
                            {service === "trustpilot" ? (
                                <>
                                    <Trustpilot />
                                    <span>Trustpilot</span>
                                </>
                            ) : undefined}
                        </div>
                    </div>
                </a>
            </SmartLink>
            <div className={cx("triangle")}></div>
        </div>
    );
};

export default Review;
